(ns ycweb.app.website.common.facebook)

;;Based off of https://github.com/netpyoung/fb-sdk-cljs  

;; Privates.
(defn wrap-keywordize-key [func]
  #?(:cljs
     (fn [resp]
       (-> resp
         (js->clj :keywordize-keys true)
         (func)))))

;;https://developers.facebook.com/docs/facebook-login/web
(defn load-sdk [fb-async-init-cb]
  #?(:cljs
     (let [doc js/document
           uid "fb-sdk-cljs"]

       (when-not (.getElementById doc uid)
         ;; register onload callback.
         (->
           js/window
           (.-fbAsyncInit)
           (set! fb-async-init-cb))

      ;; attatch facebook-sdk.
         (let [script (.createElement doc "script")]
           (-> script (.-id)    (set! uid))
           (-> script (.-async) (set! true))
           (-> script (.-src)   (set! "https://connect.facebook.net/en_US/sdk.js"))
           (let [fst-js (-> doc (.getElementsByTagName "script") (aget 0))
                 parent (.-parentNode fst-js)]

             (.insertBefore parent script fst-js)))))))

(defn init
  "ref: https://developers.facebook.com/docs/javascript/reference/FB.init"
  [params]
  #?(:cljs
     (->
       params
       (clj->js)
       (js/FB.init))))

(defn get-login-status
  "ref: https://developers.facebook.com/docs/reference/javascript/FB.getLoginStatus"
  [resp-cb]
  #?(:cljs
     (js/FB.getLoginStatus
       (wrap-keywordize-key resp-cb))))

(defn login
  "ref: https://developers.facebook.com/docs/reference/javascript/FB.login"
  ([resp-cb]
   (login resp-cb {}))
  ([resp-cb opts]
   #?(:cljs
      (js/FB.login
        (wrap-keywordize-key resp-cb)
        (clj->js opts)))))

(defn logout
  "ref: https://developers.facebook.com/docs/reference/javascript/FB.logout"
  [resp-cb]
  #?(:cljs
     (js/FB.logout
       (wrap-keywordize-key resp-cb))))

(defn api
  "ref: https://developers.facebook.com/docs/javascript/reference/FB.api"
  ([path something]
   #?(:cljs
      (js/FB.api path (if (fn? something) (wrap-keywordize-key something) (clj->js something)))))
  ([path something resp-cb]
   #?(:cljs
      (js/FB.api path (clj->js something) (wrap-keywordize-key resp-cb))))
  ([path method params resp-cb]
   #?(:cljs
      (js/FB.api path method (clj->js params) (wrap-keywordize-key resp-cb)))))